import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { Brain, ArrowRight } from 'lucide-react';

const LoginPage = () => {
  const { user, login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && user) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, user, navigate]);

  const handleGoogleLogin = () => {
    login();
  };

  return (
    <div className="min-vh-100 d-flex align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="border-0 shadow-lg">
              <Card.Body className="p-5">
                {/* Header */}
                <div className="text-center mb-4">
                  <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" 
                       style={{ width: '80px', height: '80px' }}>
                    <Brain size={40} className="text-primary" />
                     </div>
                     <h2 className="fw-bold mb-2">Willkommen bei PromptHub</h2>
                     <p className="text-muted">
                       Melde dich an, um auf deine KI-Prompt-Bibliothek zuzugreifen
                     </p>
                   </div>
   
                   {/* Login Form */}
                   <div className="text-center">
                     <Button
                       variant="outline-primary"
                       size="lg"
                       className="w-100 mb-3"
                       onClick={handleGoogleLogin}
                     >
                       <i className="fab fa-google me-2"></i>
                       Mit Google fortfahren
                     </Button>
                     
                     <p className="text-muted small mb-0">
                       Indem du fortfährst, stimmst du unseren Nutzungsbedingungen und der Datenschutzerklärung zu
                     </p>
                   </div>
   
                   {/* Features Preview */}
                   <div className="mt-5 pt-4 border-top">
                     <h6 className="fw-bold mb-3">Das bekommst du:</h6>
                     <div className="row g-3">
                       <div className="col-6">
                         <div className="d-flex align-items-center">
                           <i className="fas fa-check-circle text-success me-2"></i>
                           <span className="small">Prompt-Verwaltung</span>
                         </div>
                       </div>
                       <div className="col-6">
                         <div className="d-flex align-items-center">
                           <i className="fas fa-check-circle text-success me-2"></i>
                           <span className="small">Versionskontrolle</span>
                         </div>
                       </div>
                       <div className="col-6">
                         <div className="d-flex align-items-center">
                           <i className="fas fa-check-circle text-success me-2"></i>
                           <span className="small">Teamzusammenarbeit</span>
                         </div>
                       </div>
                       <div className="col-6">
                         <div className="d-flex align-items-center">
                           <i className="fas fa-check-circle text-success me-2"></i>
                           <span className="small">Erweiterte Suche</span>
                         </div>
                       </div>
                     </div>
                   </div>
                 </Card.Body>
               </Card>
   
               {/* Footer */}
               <div className="text-center mt-4">
                 <p className="text-muted small">
                   Brauchst du Hilfe? <a href="mailto:technik@socialvalue.de" className="text-decoration-none">Kontaktiere den Support</a>
                 </p>
               </div>
             </Col>
           </Row>
         </Container>
       </div>
     );
   };
   
   export default LoginPage;